<nav class="navbar navbar-expand-lg bg-dark navbar-dark w-100 shadow-sm">
  <div class="container-fluid">
    <img
      src="assets/images/UdSLogo_transparent.png"
      alt="vd-mit PCIbex Manager Logo"
      height="40"
      class="d-inline-block align-text-top"
      style="background: white; padding: 0em 0.5em"
    />

    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
      aria-controls="navbarContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse mx-4" id="navbarContent">
      <ul class="navbar-nav">
        <li class="nav-item mx-4">
          <a class="nav-link" routerLink="#">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" *ngIf="isAdmin" routerLink="/user-management"
            >Users</a
          >
        </li>
      </ul>
    </div>
    <div
      class="collapse navbar-collapse justify-content-end"
      id="navbarContent"
    >
      <ul class="navbar-nav">
        <li class="nav-item">
          <button class="nav-link" (click)="logout()">Log out</button>
        </li>
      </ul>
    </div>
  </div>
</nav>
